export class LabReportRequest{
    "patientId":string;
    "userId":Number;
}